import { Form, Input } from 'antd';
import Button from 'components/Button';

interface IProps {
  handleSearch: (values: any) => void;
}

export default function MasterCodeFilter(props: IProps): JSX.Element {
  const { handleSearch } = props;

  const onFinish = (values: any) => {
    const params = {
      ...values,
    };
    Object.keys(params).forEach((k) => {
      if (params[k] == '') params[k] = undefined;
    });

    handleSearch(params);
  };

  return (
    <div className="flex justify-between items-center mt-8 mb-10">
      <Form
        layout="inline"
        className="items-center"
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.Item name="code">
          <Input placeholder="Mã lỗi" className="w-44" />
        </Form.Item>
        <Form.Item name="code_name">
          <Input placeholder="Tên mã lỗi" className="w-44" />
        </Form.Item>
        <Form.Item>
          <Button type="submit">Tìm kiếm</Button>
        </Form.Item>
      </Form>
    </div>
  );
}
